export default __webpack_public_path__ + "static/28278-0e77631bc956f9e81a051c0ecddd25e8.jpg";